import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRebrandUserColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path fill="#ECE7DC" d="M16.85 7.5a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0" />
      <path
        stroke="#210E10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M3.85 20.25v-1.5a4 4 0 0 1 4-4h8.5a4 4 0 0 1 4 4v1.5M16.85 7.5a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRebrandUserColored);
export default ForwardRef;
